var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-box d-flex-center w-100 h-100",class:{
    'flex-column': _vm.directionColumn,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }